import * as React from 'react'

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect

export function useAsRef<T>(data: T) {
  const ref = React.useRef<T>(data)
  useIsomorphicLayoutEffect(() => {
    ref.current = data
  })
  return ref
}
